.badge {
  position: absolute;
  top: 12px;
  right: 12px;
  background: var(--color-ember);
  color: #111;
  font-weight: 700;
  font-size: 0.7rem;
  letter-spacing: 0.16em;
  padding: 4px 10px;
  text-transform: uppercase;
  z-index: 1;
}
